import { render } from "./ASICNonAustralianCorporate.vue?vue&type=template&id=dd0ba2e8&scoped=true&ts=true"
import script from "./ASICNonAustralianCorporate.vue?vue&type=script&lang=ts"
export * from "./ASICNonAustralianCorporate.vue?vue&type=script&lang=ts"

import "./ASICNonAustralianCorporate.vue?vue&type=style&index=0&id=dd0ba2e8&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0ba2e8"]])

export default __exports__